import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronDown, ChevronUp } from 'lucide-react';
import {} from 'react';
import { cn } from "../lib/cn.js";
import { VisuallyHidden } from "./feedback.js";
const move = (list, from, to) => {
    const next = [...list];
    const [item] = next.splice(from, 1);
    if (item !== undefined)
        next.splice(to, 0, item);
    return next;
};
export const OrderedChoiceList = ({ items, onReorder, id, className, ...aria }) => {
    const moveTo = (index, target) => {
        if (target < 0 || target >= items.length)
            return;
        onReorder(move(items, index, target));
    };
    const onKeyDown = (index) => (event) => {
        if (event.key === 'ArrowUp') {
            event.preventDefault();
            moveTo(index, index - 1);
        }
        else if (event.key === 'ArrowDown') {
            event.preventDefault();
            moveTo(index, index + 1);
        }
    };
    return (_jsxs("ol", { id: id, "aria-describedby": aria['aria-describedby'], className: cn('flex flex-col gap-1', className), children: [items.map((item, index) => {
                const position = `${String(index + 1)} de ${String(items.length)}`;
                return (_jsxs("li", { tabIndex: 0, onKeyDown: onKeyDown(index), className: cn('flex items-center gap-2 rounded-(--radius-md) border border-(--border-subtle)', 'bg-(--surface) px-2.5 py-1.5', 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--brand-primary)'), children: [_jsx("span", { className: "w-10 shrink-0 text-(length:--text-xs) tabular-nums text-(--text-muted)", children: position }), _jsx("span", { className: "flex-1 text-(length:--text-sm) text-(--text-primary)", children: item.label }), _jsxs("div", { className: "flex shrink-0 gap-0.5", children: [_jsx("button", { type: "button", "aria-label": `Mover para cima (posição ${position})`, disabled: index === 0, onClick: () => {
                                        moveTo(index, index - 1);
                                    }, className: cn('rounded-(--radius-sm) p-1 text-(--text-muted)', 'hover:bg-(--surface-hover) hover:text-(--text-primary)', 'disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:bg-transparent'), children: _jsx(ChevronUp, { "aria-hidden": "true", className: "h-3.5 w-3.5" }) }), _jsx("button", { type: "button", "aria-label": `Mover para baixo (posição ${position})`, disabled: index === items.length - 1, onClick: () => {
                                        moveTo(index, index + 1);
                                    }, className: cn('rounded-(--radius-sm) p-1 text-(--text-muted)', 'hover:bg-(--surface-hover) hover:text-(--text-primary)', 'disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:bg-transparent'), children: _jsx(ChevronDown, { "aria-hidden": "true", className: "h-3.5 w-3.5" }) })] })] }, item.value));
            }), _jsx(VisuallyHidden, { role: "status", "aria-live": "polite", children: items.length > 0
                    ? `${String(items.length)} itens na lista, em ordem.`
                    : '' })] }));
};
//# sourceMappingURL=ordered-choice-list.js.map